import { Geogroup } from '@geovelo-frontends/commons';
import { useContext } from 'react';

import { AppContext } from '../app/context';

import useUpdateGroupMembershipMutation from './use-update-group-membership-mutation';

function useTeams() {
  const {
    user: { current: currentUser },
    partner: { current: currentPartner },
    actions: { setUserTeam, setUserSite },
  } = useContext(AppContext);
  const { mutateAsync: updateGroupMembership } = useUpdateGroupMembershipMutation();

  async function updateTeam({
    partnerCode,
    userId,
    prevTeam,
    newTeamId,
  }: {
    newTeamId: number | null;
    partnerCode?: string;
    prevTeam: Geogroup | null;
    userId?: number;
  }) {
    const newTeam = await updateGroupMembership({
      partnerCode,
      userId,
      partnerId: currentPartner?.id,
      prevGroupId: prevTeam?.id ?? null,
      newGroupId: newTeamId,
    });

    if (newTeam !== undefined && (!userId || (currentUser && userId === currentUser.id))) {
      setUserTeam(newTeam);
    }
  }

  async function updateSite({
    partnerCode,
    userId,
    prevSite,
    newSiteId,
  }: {
    newSiteId: number | null;
    partnerCode?: string;
    prevSite: Geogroup | null;
    userId?: number;
  }) {
    const newSite = await updateGroupMembership({
      partnerCode,
      userId,
      partnerId: currentPartner?.id,
      prevGroupId: prevSite?.id ?? null,
      newGroupId: newSiteId,
    });

    if (newSite !== undefined && (!userId || (currentUser && userId === currentUser.id))) {
      setUserSite(newSite);
    }
  }

  async function updateSubsidiary({
    partnerCode,
    userId,
    prevSubsidiary,
    newSubsidiaryId,
  }: {
    newSubsidiaryId: number | null;
    partnerCode?: string;
    prevSubsidiary: Geogroup | null;
    userId?: number;
  }) {
    const newSite = await updateGroupMembership({
      partnerCode,
      userId,
      partnerId: currentPartner?.id,
      prevGroupId: prevSubsidiary?.id ?? null,
      newGroupId: newSubsidiaryId,
    });

    if (newSite !== undefined && (!userId || (currentUser && userId === currentUser.id))) {
      setUserSite(newSite);
    }
  }

  async function updateRegion({
    partnerCode,
    userId,
    prevRegion,
    newRegionId,
  }: {
    newRegionId: number | null;
    partnerCode?: string;
    prevRegion: Geogroup | null;
    userId?: number;
  }) {
    const newSite = await updateGroupMembership({
      partnerCode,
      userId,
      partnerId: currentPartner?.id,
      prevGroupId: prevRegion?.id ?? null,
      newGroupId: newRegionId,
    });

    if (newSite !== undefined && (!userId || (currentUser && userId === currentUser.id))) {
      setUserSite(newSite);
    }
  }

  return { updateTeam, updateSite, updateSubsidiary, updateRegion };
}

export default useTeams;
